import React, { Fragment, useState } from 'react'

type PdfMapType = {
  maps: { name: string; map: string }[]
  mapCaption: string
  style: 'c_illustration_map' | 'c_illustration_map_pattern02' | 'c_illustration_reward'
}

const PdfMap: React.FC<PdfMapType> = ({ maps, mapCaption, style = 'c_illustration_map' }) => {
  const [illustrateState, setIllustrateState] = useState<boolean>(false)

  const handleIllustrate = (e) => {
    if (e.target.classList.contains('open')) {
      e.target.classList.remove('open')
      setIllustrateState(false)
      return
    }

    e.target.classList.add('open')
    setIllustrateState(true)
  }

  return (
    <>
      {maps !== null ? (
        <div className={`${style}`}>
          <div
            className={`c_illustration_map_link relative flex flex-col items-start py-2 px-1 shadow-primary ${
              illustrateState ? '' : 'hidden'
            }`}
          >
            <>
              {maps &&
                maps.map((val: { name: string; map: string }, i: number) => {
                  return (
                    <Fragment key={i}>
                      <a
                        href={`${val.map}`}
                        className={`inline-block text-xs ${i >= 1 ? 'mt-2' : 'mt-0'}`}
                        target="_blank"
                        rel="noreferrer"
                      >
                        {val.name}
                      </a>
                    </Fragment>
                  )
                })}
            </>
          </div>
          <div className="c_illustration_map_toggle hadow-pickbox" onClick={(e) => handleIllustrate(e)} role="button">
            <p className="py-1 px-1 text-center text-xss font-bold">{mapCaption}</p>
          </div>
        </div>
      ) : (
        ''
      )}
    </>
  )
}

export default PdfMap
